export default __webpack_public_path__ + "static/media/07_tag_large-public-bath.5607d978.svg";